import { createFeatureSelector } from '@ngrx/store';
import { TResetAppCacheStore } from '@monorepo/types';

export const selectResetAppCacheStore = createFeatureSelector<TResetAppCacheStore>('RESET_APP_CACHE_STORE');
